/// <reference path="../../typings/tsd.d.ts" /> 
/// <reference path="../../typings/jquery/jquery.d.ts"/>
module warsApp.directives {

    export class WorkflowWorkspace implements IDirective {
        public controller = ['$scope', '$rootScope', '$timeout', 'workflowService', 'workflowDrawingService', 'ModalService', WorkflowWorkspaceController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/workflowWorkspace.html';
        public restrict: string = "E";

        public scope: any = {
            model: '='
        };

        public link(scope: IWorkflowWorkspaceScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: WorkflowWorkspaceController): void
        { }
    }

    export interface IWorkflowWorkspaceScope extends ng.IScope {
        model: models.WorkflowWorkspaceModel;
    }

    export class WorkflowWorkspaceController implements IController {
        private scope: IWorkflowWorkspaceScope;

        constructor(
            $scope: IWorkflowWorkspaceScope,
            $rootScope: ng.IRootScopeService,
            $timeout: ng.ITimeoutService,
            workflowService: services.WorkflowService,
            workflowDrawingService: services.WorkflowDrawingService,
            modalService: any) {
            this.scope = $scope;
            this.scope.model.injectDependencies(workflowService, workflowDrawingService, modalService, this.scope, $rootScope);

            $timeout(() => {
                this.scope.model.initialize();
            });
        }
    }
}

warsApp.registerDirective('WorkflowWorkspace', []);